<script setup lang="ts">
  import { IconImage } from '@/shared/ui';
  import UploadTipsExample from './UploadTipsExample.vue';
  import BulletPoint from './BulletPoint.vue';

  interface Requirement {
    text: string;
    emphasized?: string;
    hasLineBreak?: boolean;
  }

  interface Props {
    icon: string;
    title: string;
    requirements: Requirement[];
    example?: string;
    bulletPoint?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    bulletPoint: true,
  });
</script>

<template>
  <div class="border border-gray-02 rounded-xl p-5 w-full flex flex-col gap-3">
    <div class="flex gap-2">
      <IconImage
        :src="icon"
        alt="Method Icon"
        class="text-gray-03"
      />
      <span class="text-sm font-bold">{{ title }}</span>
    </div>

    <template
      v-for="(requirement, index) in requirements"
      :key="index"
    >
      <p class="ml-2">
        <BulletPoint v-if="bulletPoint" />
        {{ requirement.text }}
        <br v-if="requirement.hasLineBreak">
        <span
          v-if="requirement.emphasized"
          class="font-medium"
        >{{ requirement.emphasized }}</span>
      </p>
    </template>

    <slot name="after-requirements" />

    <UploadTipsExample
      v-if="example"
      :example="example"
    />
  </div>
</template>
